/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AvatarIcon from "src/assets/Avatar_Image.svg";
import CheckMark from "src/assets/Checkmark.svg";
import ChevronDownIcon from "src/assets/chevron-down.svg";
import Close from "src/assets/close-red-icon.svg";
import DeleteRedIcon from "src/assets/delete-red.svg";
import DragIcon from "src/assets/drag_indicator.svg";
import EditIcon from "src/assets/edit.svg";
import { Autocomplete, Button, Dropdown, Modal } from "src/components";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import SmartForm from "src/container/smart-form.component"; //M10-11878
import { RootState } from "src/context/store";
import { useToast } from "src/hooks/useToast";
import { queryEmployeeDetails } from "src/services/employee-api";
import {
  DeleteRegion,
  getPSRVisibleInvisibleData,
  getSearchRegionDetails,
  getVisibleInvisibleData,
  patchRegionVisibility,
} from "src/services/product-api";
import {getCityDetails} from "src/services/region-api"
import * as yup from "yup"; //M10-11878

interface Character {
  state_code: number;
  state_name: string;
  region_name: string;
  visible: boolean;
  psrcodenumeric_id: number;
  emp_name: string;
  city_name: string;
  district_name: string;
  city_code: number;
  district_code: number;
  region_type: string;
}

//M10-11878
const schema = yup.object().shape({
  reference_number: yup.string().required("Reference number is required").max(150, "Reference Number must not exceed 150 characters"),
});
//M10-11878
function DragAndDropBox() {
  const { selectedData } = useSelector((state: RootState) => state?.master);
  const [ShowForDD, setShowForDD] = useState<string>("State");
  const [characters, updateCharacters] = useState<Character[]>([]);
  const [visibility, updateVisibility] = useState<Character[]>([]);
  const [setOfCharacters, setSetOfCharacter] = useState<any>();
  const [setOfVisibility, setSetOfVisibility] = useState<any>();
  const [showVisible, setShowVisible] = useState<boolean>(true);
  const [showRemove, setShowRemove] = useState<boolean>(false);
  const [newEntityName, setNewEntityName] = useState<string>("");
  const [showAddEntity, setShowAddEntity] = useState<boolean>(false);
  const [_, setIsModalOpen] = useState<boolean>(false);
  const [inputFocused] = useState<boolean>(false);
  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [selectedRegionType, setSelectedRegionType] = useState<string>("");
  const [searchData, setSearchData] = useState<any[]>([]);
  const [SelectedDivision, setSelectedDivision] = useState<any>();
  const [IsVisibilityEraseModalOpen, setIsVisibilityEraseModalOpen] = useState(false);
  const [loader, setloader] = useState(false);
  //M10-11878
  const [showReferenceNumber, setShowReferenceNumber] = useState<boolean>(false);
  const [selectType, setSelectType] = useState<any>('');
  //M10-11878
  const [visibilityConfigByType, setVisibilityConfigByType] = useState<{
    [key: string]: string;
  }>({ State: "", City: "", District: "", PSR: "" });

  console.log("inputFocused, selecetdCompany :>> ", inputFocused, selectedCompany);

  const { toast } = useToast();

  // const tabs = [
  //   {
  //     id: "psr",
  //     title: "PSR",
  //   },
  //   {
  //     id: "state",
  //     title: "State",
  //   },
  //   {
  //     id: "city",
  //     title: "City",
  //   },
  //   {
  //     id: "district",
  //     title: "District",
  //   },
  // ];

  // const handleInputFocus = () => {
  //   setInputFocused(true);
  //   setIsModalOpen(true);
  // };

  // const handleInputBlur = () => {
  //   setInputFocused(false);
  // };

  // const handleNewEntityNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setNewEntityName(e.target.value);
  // };

  function getFirstLetter(word: string) {
    if (word.length > 0) {
      return word[0].toUpperCase(); // Access the first character at index 0
    } else {
      return null; // Handle the case where the input is not a valid word
    }
  }

  const handleEraseValue = (reference_number?:any) => { //M10-11878
    console.log("selectedRegionType", selectedRegionType);
    console.log("newEntityName", newEntityName);
    if (newEntityName.trim() !== "") {
      const body = {
        item_code: selectedData?.company_productcode || "",
        company_divisioncode: JSON.parse(SelectedDivision?.company_divisioncode),
        isVisible: showVisible,
        region_code: selectedRegionType,
        region_type: getFirstLetter(ShowForDD),
        product_item_code: selectedData?.item_code,
        region_name: newEntityName,
        division_name: SelectedDivision?.division_name,
        reference_number: reference_number  //M10-11878
      };

      const psrBody = {
        item_code: selectedData?.company_productcode || "",
        company_divisioncode: JSON.parse(SelectedDivision?.company_divisioncode),
        isVisible: showVisible,
        psrcodenumeric_id: selectedRegionType,
        product_item_code: selectedData?.item_code,
        division_name: SelectedDivision?.division_name,
        reference_number: reference_number  //M10-11878
      };
      if (ShowForDD === "PSR") {
        patchRegionVisibility(`/psr/add`, psrBody, "PRODUCT_VISIBLITY_PSR_ADD")
          .then(async () => {
            toast({ description: "PSR has been added successfully" });
            setloader(true);
            setTimeout(async () => {
              await getPSRVisibilityData(SelectedDivision);
              setloader(false);
              toast({ description: "New data has been updated" });
            }, 2000);
            handleCancelAddEntity();
            setIsVisibilityEraseModalOpen(false);
          })
          .catch((e) => {
            setIsVisibilityEraseModalOpen(false);
            console.log("e :>> ", e);
            toast({
              variant: "destructive",
              description: "Data update failed",
            });
          });
      } else {
        patchRegionVisibility(`/region/add`, body, "PRODUCT_VISIBLITY_REGION_ADD")
          .then(async () => {
            toast({ description: "Region has been added successfully" });
            setloader(true);
            setTimeout(async () => {
              await getVisibilityData(SelectedDivision);
              setloader(false);
              toast({ description: "New data has been updated" });
            }, 2000);
            handleCancelAddEntity();
            setIsVisibilityEraseModalOpen(false);
          })
          .catch((e) => {
            console.log("e :>> ", e);
            setIsVisibilityEraseModalOpen(false);
            toast({
              variant: "destructive",
              description: "Data update failed",
            });
          });
      }
    }
  };

  console.log("updateVisibility", visibility);
  console.log("Characters", characters);
  console.log("selectedRegionType", selectedRegionType);

  const handleSaveEntity = (reference_number?:any) => { //M10-11878
    if (showVisible) {
      const isRegionCodeSame = visibility.some((item: any) => item.region_code === selectedRegionType);
      console.log("Is region code same: ", isRegionCodeSame);
      if (isRegionCodeSame) {
        setIsVisibilityEraseModalOpen(true);
        return;
      } else {
        handleEraseValue(reference_number); //M10-11878
      }
    } else {
      const isRegionCodeSame = characters.some((item: any) => item.region_code === selectedRegionType);
      console.log("Is region code same: ", isRegionCodeSame);
      if (isRegionCodeSame) {
        setIsVisibilityEraseModalOpen(true);
        return;
      } else {
        handleEraseValue(reference_number); //M10-11878
      }
    }
  };

  const getVisibilityData = async (division?: any) => {
    if (!selectedData?.company_productcode) {
      return;
    }

    if (!division?.company_divisioncode && !selectedData?.item_division?.[0]?.company_divisioncode?.company_divisioncode) {
      return;
    }

    const result = await getVisibleInvisibleData(
      selectedData?.company_productcode?.toString() || "",
      division?.company_divisioncode || selectedData?.item_division?.[0]?.company_divisioncode?.company_divisioncode || ""
    );

    if (result) {
      if (result.status === 200) {
        const response = result.data.data;
        const a = [];
        const b = [];
        const visibilitySet = new Set();
        const characterSet = new Set();
        console.log("Region data", response);
        for (let i = 0; i < response.length; i++) {
          if (!response[i].isVisible) {
            b.push(response[i]);
            visibilitySet.add(String(response[i]?.region_code));
          } else {
            a.push(response[i]);
            characterSet.add(String(response[i]?.region_code));
          }
        }

        setVisibilityConfigByType((prev) => {
          const updatedConfig = { ...prev };

          response.forEach((item: any) => {
            const type = item.region_type?.toUpperCase();
            const visibility = item.isVisible ? "Visible" : "Invisible";

            if (type === "S") updatedConfig.State = visibility;
            if (type === "C") updatedConfig.City = visibility;
            if (type === "D") updatedConfig.District = visibility;
          });

          return updatedConfig;
        });

        updateCharacters(a);
        setSetOfCharacter(characterSet);
        updateVisibility(b);
        setSetOfVisibility(visibilitySet);
      }
    }
  };

  const getPSRVisibilityData = async (division?: any) => {
    const result = await getPSRVisibleInvisibleData(
      selectedData?.company_productcode,
      JSON.parse(division?.company_divisioncode || selectedData?.item_division?.[0]?.company_divisioncode?.company_divisioncode)
    );

    if (result) {
      if (result.status === 200) {
        const response = result.data.data;
        const a = [];
        const b = [];
        const visibilitySet = new Set();
        const characterSet = new Set();
        console.log(response);

        if (response?.length > 0) {
          setVisibilityConfigByType((prev) => ({
            ...prev,
            PSR: response?.[0]?.isVisible ? "Visible" : "Invisible",
          }));
        }

        for (let i = 0; i < response.length; i++) {
          if (!response[i].isVisible) {
            b.push(response[i]);
            visibilitySet.add(String(response[i]?.empmaster_id));
          } else {
            a.push(response[i]);
            characterSet.add(String(response[i]?.empmaster_id));
          }
        }
        updateCharacters(a);
        setSetOfCharacter(characterSet);

        updateVisibility(b);
        setSetOfVisibility(visibilitySet);
      }
    }
  };

  const getEmployeeSearchData = (division?: any) => {
    queryEmployeeDetails(
      `/details?division_id=${division?.company_divisioncode || SelectedDivision.company_divisioncode}&company_id=${selectedData?.company_code?.code}`
    )
      .then((res) => {
        setSearchData(res?.data?.data || []);
      })
      .catch((e) => console.log("error of employee search", e));
  };

  interface Entity {
    region_code: string;
    company_divisionCode: string;
    item_code: string;
    region_type: string;
    product_item_code: string | number;
    region_name: string;
    division_name: string;
    u_code: string;
    isVisible: boolean | string;
    reference_number: string; //M10-11878
  }

  interface PsrBody {
    psr_code_numeric_nn: string;
    company_divisioncode: string;
    item_code: string;
    product_item_code: string | number;
    division_name: string;
    u_code: string;
    isVisible: boolean | string;
    reference_number: string; //M10-11878
  }

  interface Item extends PsrBody {
    psrcodenumeric_id: string;
  }

  // Type guard to check if a given item is of type Entity
  function isEntity(item: Entity | Item): item is Entity {
    return (item as Entity).region_code !== undefined;
  }

  const handleRemoveEntity = (index: number, item: Entity | Item | any, reference_number?: any) => {//M10-11878
    let endpoint: string;
    let requestBody: Entity | PsrBody;

    console.log("index", index);
    console.log("item", item);

    if (isEntity(item)) {
      requestBody = {
        region_code: item.region_code,
        company_divisionCode: SelectedDivision?.company_divisioncode,
        item_code: selectedData?.company_productcode || "",
        region_type: getFirstLetter(ShowForDD) || "",
        product_item_code: selectedData?.item_code,
        region_name: item?.region_name,
        division_name: SelectedDivision?.division_name,
        u_code: item?.u_code,
        isVisible: item?.isVisible,
        reference_number: reference_number  //M10-11878
      };
      endpoint = "region/delete";
    } else {
      requestBody = {
        psr_code_numeric_nn: item.empmaster_id,
        company_divisioncode: SelectedDivision?.company_divisioncode,
        item_code: selectedData?.company_productcode || "",
        product_item_code: selectedData?.item_code,
        division_name: SelectedDivision?.division_name,
        u_code: item?.u_code,
        isVisible: item?.isVisible,
        reference_number: reference_number  //M10-11878
      };
      endpoint = "psr/delete";
    }

    DeleteRegion(
      endpoint,
      requestBody,
      selectedData?.company_productcode,
      ShowForDD === "PSR" ? "PRODUCT_VISIBLITY_PSR_DELETE" : "PRODUCT_VISIBLITY_REGION_DELETE"
    )
      .then((data: any) => {
        console.log(`remove ${ShowForDD} data response`, data);
        toast({ description: isEntity(item) ? "Region has been Successfully deleted" : "PSR has been Successfully deleted" });
        setTimeout(async () => {
          isEntity(item) ? await getVisibilityData(SelectedDivision) : await getPSRVisibilityData(SelectedDivision);
          toast({ description: "Data has been Successfully fetched" });
        }, 2000);
      })
      .catch((e: Error) => {
        console.error("Error :>> ", e);
      });
  };

  const handleCancelAddEntity = () => {
    setShowAddEntity(false);

    setNewEntityName("");
    setIsModalOpen(false);
  };

  const toggleEdit = () => {
    setShowRemove(!showRemove);
  };

  // Server-side region search: passes the typed text to the API as `?search=<query>`
  // (used for State / City / District). Returns options already mapped + filtered
  // against the regions that are currently configured.
  const fetchRegionSuggestions = async (query?: string) => {
    try {
      const search = query?.trim() ?? "";
      let response;

      if (ShowForDD === "City") {
        response = await getCityDetails(`?search=${search}`);
      } else {
        response = await getSearchRegionDetails(`${ShowForDD}?search=${search}`);
      }

      const list = response?.data?.data ?? [];

      return list
        .map((item: any) => ({
          name:
            ShowForDD === "State" ? item?.state_name : ShowForDD === "City" ? item?.city_name : item?.district_name,
          code: item[`${ShowForDD.toLowerCase()}_code`],
        }))
        .filter((filterItem: any) => {
          const alreadyAdded = showVisible
            ? setOfCharacters?.has(String(filterItem?.code))
            : setOfVisibility?.has(String(filterItem?.code));
          return !alreadyAdded;
        });
    } catch (error) {
      console.error("Error fetching region search data:", error);
      return [];
    }
  };

  const SimplifyRegionType: any = { S: "State", C: "City", D: "District" };
  
  // M10-13543
  // Once an entity has been configured, its hierarchy becomes the hierarchy for
  // this product/division. This prevents mixing State, City, District and PSR
  // entities in the same visibility configuration.
  const configuredHierarchy = [...characters, ...visibility]
    .map((item: any) => {
      if (SimplifyRegionType[item?.region_type]) return SimplifyRegionType[item.region_type];
      if (["State", "City", "District", "PSR"].includes(item?.region_type)) return item.region_type;
      return item?.empmaster_id !== undefined || item?.emp_name ? "PSR" : undefined;
    })
    .find(Boolean);

  const hierarchyOptions = configuredHierarchy
    ? [{ label: configuredHierarchy }]
    : [{ label: "PSR" }, { label: "State" }, { label: "City" }, { label: "District" }];

  useEffect(() => {
    if (configuredHierarchy && ShowForDD !== configuredHierarchy) {
      setShowForDD(configuredHierarchy);
      setShowAddEntity(false);
    }
  }, [configuredHierarchy, ShowForDD]);
  // M10-13543

  useEffect(() => {
    if (selectedData) {
      if (ShowForDD === "PSR") {
        getEmployeeSearchData();
      } else {
        getVisibilityData();
        getPSRVisibilityData();
      };
    }
  }, [selectedData, ShowForDD]);

  useEffect(() => {
    setSelectedDivision((selectedData && selectedData?.item_division?.[0]?.company_divisioncode) || "");
  }, []);

  async function divisionHandler(value: any) {
    setSelectedDivision(value);
    if (ShowForDD === "PSR") {
      getPSRVisibilityData(value);
      getEmployeeSearchData(value);
    } else getVisibilityData(value);
  }


  const currentType = ShowForDD; 
  const visibilityType = visibilityConfigByType[currentType]; 

  const disableVisible = visibilityType === "Invisible"; 
  const disableInvisible = visibilityType === "Visible";  


  return (
    <div className="border product-visibility rounded-xl">
      <div className="flex items-center gap-4 p-4 border-b box">
        <div className="flex-1 text-xl font-semibold">Product Visibility</div>
        {selectedData && selectedData?.item_division && (
          <Dropdown
            placeholder="Division"
            displayKey="company_divisioncode"
            hierarchyDisplay="division_name"
            menuItems={selectedData?.item_division}
            onOptionClick={(value: any) => {
              console.log("value", value);
              divisionHandler(value?.company_divisioncode);

              console.log("setSelectedDivision", SelectedDivision);
            }}
            currentSelected={SelectedDivision?.division_name}
            icon={ChevronDownIcon}
          />
        )}
        <Dropdown
          placeholder="hierarchy"
          displayKey="label"
          // M10-13543
          menuItems={hierarchyOptions}
          // M10-13543
          onOptionClick={(value: any) => {
            setShowAddEntity(false);
            setShowForDD(value.label.toString());
          }}
          currentSelected={ShowForDD}
          icon={ChevronDownIcon}
        />
      </div>
      <div className="relative">
        <div>
          <div className="flex items-center justify-between mt-2 ml-4">
            <div className="flex items-center justify-center bg-[#f6f6f6]  rounded-xl px-1 py-1">
              <div className={showVisible ? "active" : "inactive"}>
                <Button
                  module={fineGrainedPermissionsKeys.PRODUCT.PRODUCTVISIBILITY.module}
                  action={fineGrainedPermissionsKeys.PRODUCT.PRODUCTVISIBILITY.action}
                  onClick={() => setShowVisible(true)}
                  disabled={disableVisible}
                  className={`${disableVisible ? "cursor-not-allowed opacity-20" : ""}`}
                >
                  Visible
                </Button>
              </div>
              <div className={!showVisible ? "active" : "inactive"}>
                <Button
                  module={fineGrainedPermissionsKeys.PRODUCT.PRODUCTVISIBILITY.module}
                  action={fineGrainedPermissionsKeys.PRODUCT.PRODUCTVISIBILITY.action}
                  onClick={() => setShowVisible(false)}
                  disabled={disableInvisible}
                  className={`${disableInvisible ? "cursor-not-allowed opacity-20" : ""}`}
                >
                  Invisible
                </Button>
              </div>
            </div>

            <div>
              <Button onClick={toggleEdit} className="border items-center mr-4 bg-[#e9e9e9] border-[#d1d1d1]">
                <img src={EditIcon} alt="edit product" className="w-4 h-4" />
                Edit
              </Button>
            </div>
          </div>

          {showVisible ? (
            <div className="mx-4 mt-3">
              {characters.map(
                (item, index) =>
                  (ShowForDD === SimplifyRegionType[item?.region_type] || ShowForDD === "PSR") && (
                    <div key={index} className="flex items-center bg-[#f6f6f6] mb-3 rounded-xl pl-3 whitespace-nowrap">
                      <img src={DragIcon} alt="edit product" className="w-5 h-5" />
                      <img src={AvatarIcon} alt="edit product" className="w-5 h-5 mx-2" />
                      <div className="p-2">{ShowForDD === "PSR" ? item.emp_name : item.region_name}</div>
                      <div className="flex justify-end w-full pr-2">
                        {showRemove && (
                            <Button
                              onClick={() => {
                                //M10-11878
                                setSelectType({ index, item });
                                setShowReferenceNumber(true)
                              }}
                              className="bg-[#f7eaed] items-flex-end text-[#db6261]  relative pl-1 pr-3 py-1 rounded-lg"
                            >
                              <img src={DeleteRedIcon} alt="edit product" className="w-6 h-6" />
                              Remove
                            </Button>
                          )}
                      </div>
                    </div>
                  )
              )}
            </div>
          ) : (
            <div className="mx-4 mt-3">
              {visibility.map(
                (item, index) =>
                  (ShowForDD === SimplifyRegionType[item?.region_type] || ShowForDD === "PSR") && (
                    <div key={index} className="flex items-center bg-[#f6f6f6] mb-3 rounded-xl pl-3 whitespace-nowrap">
                      <img src={DragIcon} alt="edit product" className="w-5 h-5" />
                      <img src={AvatarIcon} alt="edit product" className="w-5 h-5 mx-2" />
                      <div className="p-2">{ShowForDD === "PSR" ? item.emp_name : item.region_name}</div>

                      <div className="flex justify-end w-full pr-2">
                        {showRemove && (
                            <Button
                              onClick={() => handleRemoveEntity(index, item)}
                              className="bg-[#f7eaed] items-flex-end text-[#db6261]  relative pl-1 pr-3 py-1 rounded-lg"
                            >
                              <img src={DeleteRedIcon} alt="edit product" className="w-6 h-6" />
                              Remove
                            </Button>
                          )}
                      </div>
                    </div>
                  )
              )}
            </div>
          )}

          <div>
            {showAddEntity ? (
              <div className="flex items-center bg-[#f6f6f6] mb-3 rounded-xl pl-3 whitespace-nowrap mx-4 py-2 ">
                <img src={DragIcon} alt="edit product" className="w-5 h-5" />
                <img src={AvatarIcon} alt="edit product" className="w-5 h-5 mx-2" />
                <Autocomplete
                  inputClassName="w-full"
                  placeholder={`Type a ${ShowForDD?.toLowerCase()} name...`}
                  // For State/City/District the typed text is sent to the API (`?search=`)
                  // via fetchRegionSuggestions; PSR keeps the locally-loaded suggestion list.
                  asyncListFunction={ShowForDD !== "PSR" ? fetchRegionSuggestions : undefined}
                  suggestionList={
                    !Array.isArray(searchData)
                      ? []
                      : searchData
                          ?.map((item: any) => {
                            const resObj = {
                              name:
                                ShowForDD === "PSR"
                                  ? item?.emp_name
                                  : ShowForDD === "State"
                                    ? item?.state_name
                                    : ShowForDD === "City"
                                      ? item?.city_name
                                      : item?.district_name,
                              code: ShowForDD === "PSR" ? item?.empmaster_id : item[`${ShowForDD.toLowerCase()}_code`], // Assuming region_type represents the code
                            };
                            return resObj;
                          })
                          ?.filter((filterItem: any) => {
                            const foundItem = showVisible
                              ? setOfCharacters?.has(String(filterItem?.code))
                              : setOfVisibility?.has(String(filterItem?.code));
                            if (foundItem) return false;
                            else return true;
                          })
                  }
                  displayKey={"name"}
                  uniqueKey="code"
                  onSelectionChange={(selectedCompany: { name: string; code: string }) => {
                    setSelectedRegionType(selectedCompany.code);
                    setSelectedCompany(selectedCompany.name);
                    setIsModalOpen(false);
                    setNewEntityName(selectedCompany.name);
                  }}
                />
                {/* <input
                  type="text"
                  value={newEntityName}
                  onChange={handleNewEntityNameChange}
                  className="bg-[#f6f6f6] border border-[#a4a3a5] rounded"
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                /> */}
                <div className="flex justify-end w-full">
                  {/* M10-11878 */}
                  <img src={CheckMark} className="w-6 h-6 ml-4 mr-2" onClick={() => {
                    setSelectType("Accept")
                    setShowReferenceNumber(true)
                  }} />
                  <img
                    src={Close}
                    className="w-6 h-6 mr-2 "
                    onClick={() => {
                      handleCancelAddEntity();
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="mx-2 my-2 ">
                <Button
                  className="bg-[#7F56D9] text-white w-full"
                  onClick={() => {
                    setShowAddEntity(true);
                    // Region types (State/City/District) search server-side through the
                    // Autocomplete's asyncListFunction, so only PSR needs an eager load.
                    if (ShowForDD === "PSR") getEmployeeSearchData();
                  }}
                >
                  {loader ? <p className="text-[#2D1E6A]">Adding in process</p> : <p>Add Entity</p>}
                </Button>
              </div>
            )}
            {/* {isModalOpen && (
              <div className="absolute border product-visibility rounded-xl">
                <Tabs tabs={tabs} ActiveTab={ShowForDD.toLowerCase()} />
                <Autocomplete
                  inputClassName="w-full"
                  placeholder={`Type a ${ShowForDD?.toLowerCase()} name...`}
                  suggestionList={searchData.map((item: any) => ({
                    name:
                      ShowForDD === "PSR"
                        ? item.emp_name
                        : ShowForDD === "State"
                        ? item.state_name
                        : ShowForDD === "City"
                        ? item.city_name
                        : item.district_name,
                    code: ShowForDD === "PSR" ? item["psrcodenumeric_id"] : item[`${ShowForDD.toLowerCase()}_code`], // Assuming region_type represents the code
                  }))}
                  displayKey="name"
                  uniqueKey="code"
                  onSelectionChange={(selectedCompany: { name: string; code: string }) => {
                    setSelectedRegionType(selectedCompany.code);
                    setSelectedCompany(selectedCompany.name);
                    setIsModalOpen(false);
                    setNewEntityName(selectedCompany.name);
                  }}
                />
              </div>
            )} */}
          </div>
        </div>
      </div>
      <Modal isOpen={IsVisibilityEraseModalOpen} isHeader={false} onCloseModal={setIsVisibilityEraseModalOpen}>
        <div className="p-6 w-[25rem]">
          <h1 className="text-[1.75rem] text-[#101828]  not-italic font-semibold leading-7">Erase the value</h1>
          <p className="text-sm font-normal text-[#667085] mt-2 ">Values already configured? Do you want to erase?</p>

          {/* <h2 className="mt-8 text-[#101828] text-xl font-semibold">
            Before you delete...
          </h2> */}

          {/* <p className="mt-2 p-0 font-normal text-sm text-[#667085]">
            If you wish to replace this product with another, you can
            <span
              onClick={() => setreplaceProduct(true)}
              className="underline text-[#7F56D9] cursor-pointer mx-1"
            >
              click here
            </span>
            to do that.
          </p> */}

          <footer className="flex items-center justify-between gap-3 mt-8">
            <Button onClick={() => setIsVisibilityEraseModalOpen(false)} className="border bg-primary text-white flex-1 py-[0.62rem]">
              Keep value
            </Button>
            <Button onClick={handleEraseValue} className="border flex-1  py-[0.62rem]">
              Erase now
            </Button>
          </footer>
        </div>
      </Modal>
      {/* M10-11878 */}
      {showReferenceNumber && (
        <div className="w-11/12 sm:w-10/12 md:w-9/12">
          <Modal
            title="Reference Number"
            isHeader={true}
            isOpen={showReferenceNumber}
            onCloseModal={() => {
              setShowReferenceNumber(false);
            }}
            onBack={() => {
              setIsModalOpen(true);
              setShowReferenceNumber(false);
            }}
          >
            <div className="p-5">
              <SmartForm
                defaultValues={{}}
                onFormSubmit={(data: any) => {
                  if (selectType && selectType.index !== undefined && selectType?.item) {
                    handleRemoveEntity(selectType?.index, selectType?.item, data?.reference_number)
                  } else {
                    handleSaveEntity(data?.reference_number)
                  }
                  setShowReferenceNumber(false);
                }}
                schema={schema}
              >
                <SmartForm.Input placeholder="" type="text" fieldName="reference_number" className="w-full" label="Reference Number" />
                <footer className="flex gap-3 justify-between items-center mt-8">
                  <Button
                    onClick={() => {
                      setShowReferenceNumber(false);
                    }}
                    className="border bg-primary text-white flex-1 py-[0.62rem]"
                  >
                    Cancel
                  </Button>
                  <Button type="submit" className="border flex-1  py-[0.62rem]">
                    Submit
                  </Button>
                </footer>
              </SmartForm>
            </div>
          </Modal>
        </div>
      )}
      {/* M10-11878 */}
    </div>
  );
}

export default DragAndDropBox;
